import ElementContent from '@/components/sections/builder/elements/body/image-banner/content';
import ElementSetting from '@/components/sections/builder/elements/body/image-banner/setting';
import ImageBannerButtonGroup from '@/components/sections/builder/elements/body/image-banner/button-group';
import ImageBannerSubtitle from '@/components/sections/builder/elements/body/image-banner/subtitle';
import ImageBannerTitle from '@/components/sections/builder/elements/body/image-banner/title';
import { ImageBannerElementDataType } from '@/components/sections/builder/elements/body/image-banner/types';
import { GalleryHorizontal } from 'lucide-react';

const defaultData: ImageBannerElementDataType = {
  name: 'Image Banner',
  contentAlign: 'center',
  contentAlignMobile: 'center',
  height: 'small',
  showContainerDesktop: true,
  contentPosition: 'middle-center',
  firstImage: 'https://placehold.co/300x200',
  backgroundAnimation: 'none',
  mobileMinWidth: 720,
};

export const ElementPreviewIcon = GalleryHorizontal;

const ImageBanner = {
  type: 'image_banner',
  group: 'body',
  defaultData,
  Element: ElementContent,
  Setting: ElementSetting,
  PreviewIcon: ElementPreviewIcon,
  defaultChilds: [ImageBannerTitle, ImageBannerSubtitle, ImageBannerButtonGroup],
  childs: [ImageBannerTitle, ImageBannerSubtitle, ImageBannerButtonGroup],
};

export default ImageBanner;
